<script>
import videoList from './expert-team-data'

export default {
  data: () => ({
    videoList
  }),
  computed: {
    detail () {
      return videoList[this.$route.params.index]
    }
  }
}
</script>

<template>
  <div class="expert_team_video container">
    <div class="expert_team_video_main">
      <video :src="detail.videoUrl" controls class="video__inner"></video>
    </div>
    <div class="expert_team_poster">
      <img class="image__inner" :src="detail.poster + '?imageMogr2/format/webp'" />
    </div>
  </div>
</template>

<style scoped lang="scss">
  .container {
    width: 1087px;
    margin: 0 auto;
  }
  .expert_team_video {
    padding: 30px 0;
  }

  .expert_team_video_main {
    .video__inner {
      width: 100%;
      object-fit: contain;
    }
  }

  .expert_team_poster {
    padding-top: 20px;
    .image__inner {
      width: 100%;
      object-fit: contain;
    }
  }
</style>